import styled from 'styled-components';
import { StyledWrapper } from '../styled';

export const StyledWrapperContainer = styled(StyledWrapper)`
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
`;

export const StyledCupGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(240px, 320px);
  gap: 25px;
  align-items: stretch;
  width: 100%;

  @media only screen and (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledBracketColumn = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const StyledCalendarColumn = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 1199px) {
    display: none;
  }

  > * {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const StyledBracketCard = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  justify-content: space-between;
  align-items: center;
  padding: 16px 8px;
  box-sizing: border-box;
  @media only screen and (max-width: 1199px) {
    display: none;
  }
`;

export const StyledGroupMatch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-width: 720px;
  justify-content: space-between;
  position: relative;
`;

export const StyledMobileLeague = styled.div`
  display: none;
  @media only screen and (max-width: 1199px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: ${({ theme }) => theme.card};
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: ${({ theme }) => theme.cardRadius};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
    padding: 16px 16px 8px;
    box-sizing: border-box;
    overflow: hidden;
  }
`;

export const StyledPlayingSectionPreloader = styled.div`
  border-radius: ${({ theme }) => theme.cardRadius};
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  overflow: hidden;
  min-height: 112px;
  margin-bottom: 24px;
`;

export const StyledSectionPreloader = styled.div`
  flex: 1;
  border-radius: ${({ theme }) => theme.cardRadius};
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  overflow: hidden;
  min-height: 220px;
`;

export const StyledBracketPreloader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-radius: ${({ theme }) => theme.cardRadius};
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  overflow: hidden;
  min-height: 280px;
  padding: 16px 8px;
  box-sizing: border-box;
  @media only screen and (max-width: 1199px) {
    display: none;
  }
`;
